import type { ActKc2SelectionData } from 'gql/graphql';
import {
    costGroupFormatter,
    dateFormatter,
    GroupManagerCheckboxCellRenderer,
    GroupManagerCheckboxHeaderRenderer,
    GroupNameAndNumberRenderer,
} from 'pages/Project/Common/ActsKC2ListContainer';

import type { ColDef, ColGroupDef } from 'ag-grid-community';
import { useMemo } from 'react';
import type { Control } from 'react-hook-form';

export const useUerActsKc2GroupManagerColumns = ({ control }: { control: Control<any> }) =>
    useMemo<(ColDef<ActKc2SelectionData> | ColGroupDef<ActKc2SelectionData>)[]>(
        () => [
            {
                field: 'menu' as any,
                minWidth: 60,
                maxWidth: 60,
                pinned: 'left',
                lockPosition: 'left',
                headerComponent: GroupManagerCheckboxHeaderRenderer,
                cellRenderer: GroupManagerCheckboxCellRenderer,
                cellRendererParams: {
                    control,
                },
                headerComponentParams: {
                    control,
                },
            },
            {
                headerName: 'Номер акта',
                field: 'number',
                cellRenderer: GroupNameAndNumberRenderer,
                width: 160,
            },
            {
                headerName: 'Дата акта',
                field: 'actDate',
                valueFormatter: dateFormatter('actDate'),
                width: 160,
            },
            {
                headerName: 'Отчетный период',
                width: 300,
                marryChildren: true,
                children: [
                    {
                        headerName: 'Начало',
                        field: 'startDate',
                        valueFormatter: dateFormatter('startDate'),
                    },
                    {
                        headerName: 'Окончание',
                        field: 'finishDate',
                        valueFormatter: dateFormatter('finishDate'),
                    },
                ],
            },
            {
                headerName: 'Группа затрат',
                field: 'costGroup',
                valueFormatter: costGroupFormatter,
                width: 160,
            },
            {
                headerName: 'Вид стр-ва',
                field: 'constructionType.name',
                width: 160,
            },
            {
                headerName: 'Объект',
                field: 'workOrderObjectName',
                width: 160,
            },
        ],
        [control],
    );
